<script>
export default {
  name: 'SubBubbleAgreementsListActions',
}
</script>

<template>
  <section class="mb-4">
    <v-row>
      <v-col></v-col>
      <v-col cols="auto">
        <v-btn
          color="primary"
          data-testid="add-new-sub-bubble-agreement-btn"
          @click="$emit('on-add-new')"
          >{{ $t('subBubbleAgreements.addSubBubbleAgreementBtnText') }}</v-btn
        >
      </v-col>
    </v-row>
  </section>
</template>
